const pxToGridY = (y: number): number => (y + 10) / 20

export const resizeY = (
    dashboardContext: LiveDashboardContextValue,
    mode: Mode,
    id: string | number,
    y: number
): void => {
    if (!dashboardContext) {
        return
    }
    const { actions, dashboard } = dashboardContext

    if (dashboard?.jsonConfig && dashboard?.jsonConfig?.layoutModes) {
        dashboard.jsonConfig.layoutModes[mode].grid[String(id)].size_y = pxToGridY(y)
        dashboard.jsonConfig.layoutModes[mode].gridRowHeight = 'static'
        const {
            jsonConfig: { layoutModes }
        } = dashboard
        actions.updateUserLayout(layoutModes[mode])
    }
}
